import { generateUUID4 } from '../data/random';
export interface IWebviewBridge {
    subscribe(callbackFn: ((message) => void)): () => void;
}
export interface IMessage {
    messageHandlerId: string;
    action: string;
    data?: {};
}

const WEBVIEW_BRIDGE_MESSAGE = 'message';
const WEBVIEW_BRIDGE_MESSAGE_DOMAIN = '*';
export default class WebviewBridge implements IWebviewBridge {
    private subscribers: {};
    constructor() {
        this.subscribers = {};
        this.onMessageHandler = this.onMessageHandler.bind(this);
    }
    // UUID is added to because react-proxy saves states without destroying the exting one.
    public subscribe(callbackFn) {
        const callBackUuid = generateUUID4();
        if (callbackFn) {
            this.subscribers[callBackUuid] = callbackFn;
        }
        return () => {
            return this.unsubscribe(callBackUuid);
        };
    }

    // passed as an argument to message handler
    public onMessageHandler(event) {
        let msgData;
        try {
            msgData = event.hasOwnProperty('nativeEvent')
                ? JSON.parse(event.nativeEvent.data)
                : JSON.parse(event.data);
            this.publishMessageToSubscribers(msgData);
        } catch (err) {
            return;
        }
    }

    public listenToDomEvents() {
        if (window) {
            window.document.removeEventListener(
                WEBVIEW_BRIDGE_MESSAGE,
                this.onMessageHandler
            );
            window.document.addEventListener(
                WEBVIEW_BRIDGE_MESSAGE,
                this.onMessageHandler
            );
        }
    }

    public sendMessageToWebView(message: IMessage, target) {
        if (target && target.hasOwnProperty('postMessage')) {
            target.postMessage(JSON.stringify(message));
        }
    }

    public sendMessageToRN(message: IMessage) {
        if (window && window.hasOwnProperty('postMessage')) {
            window.postMessage(
                JSON.stringify(message),
                WEBVIEW_BRIDGE_MESSAGE_DOMAIN
            );
        }
    }

    private unsubscribe(callBackUuid) {
        if (this.subscribers[callBackUuid] === undefined) {
            return;
        }
        delete this.subscribers[callBackUuid];
    }

    private publishMessageToSubscribers(message: IMessage) {
        if (
            !message &&
            this.subscribers[message.messageHandlerId] === undefined
        ) {
            return;
        }
        Object.keys(this.subscribers).forEach((callBackUuid) => {
            this.subscribers[callBackUuid](message);
        });
    }
}

export const webviewBridge = new WebviewBridge();
